import React, { ReactNode } from "react";
import cx from "classnames";
import ContentLoader from "react-content-loader";
import SVGIcon from "@arrive/svg-icon";
import Button from "@arrive/button";

import { testIdHelper } from "helpers/formatters";

import colors from '@arrive/style-foundation/variables/colors-js.scss';
import styles from './CommonComponents.scss';

const { tandem } = colors;
const foregroundColor = '#FAFAFA';

export const SectionTitle = ({ icon, title, subtitle, type }: { icon?: { id: string; viewBox: string }; title: string; subtitle?: string; type?: string }) => {

  return (
    <h3 className={styles.sectionTitle} data-testid={testIdHelper(title, 'section-title')}>
      { icon && <SVGIcon className={styles.titleIcon} svgRef={icon} /> }
      <div className={styles.sectionTitleTextContainer}>
        {title}
        {subtitle && <span className={styles.sectionTitleSubtitle}>{subtitle}</span>}
      </div>
      {type && <div className={styles.sectionTitleType}>{type}</div>}
    </h3>
  )
}

export const EditableSectionTitle = ({ icon, title, subtitle, type, edit, onEdit }: { icon?: { id: string; viewBox: string }; title: string; subtitle?: string; type?: string, edit: boolean, onEdit: () => void }) => {

  return (
    <>
      <h3 className={styles.sectionTitle} data-testid={testIdHelper(title, 'section-title')}>
        { icon && <SVGIcon className={styles.titleIcon} svgRef={icon} /> }
        <div className={styles.sectionTitleTextContainer}>
          <div>
            {title}
          </div>
          {subtitle && <span className={styles.sectionTitleSubtitle}>{subtitle}</span>}
        </div>
        {type && <div className={styles.sectionTitleType}>{type}</div>}
        {!edit && <Button type='secondary' text onClick={onEdit} data-testid={testIdHelper(title, 'edit')}>edit</Button>}
      </h3>
    </>
  )
}

export const EditableSectionButtons = ({ className, onCancel, onSave, disabled, loading }: { className?: string; onCancel: () => void; onSave: () => void; disabled?: boolean; loading: boolean;}) => {
  return (
    <div className={cx(styles.editableSectionButtonsContainer, className)}>
      <Button disabled={loading} onClick={onCancel} type="secondary" data-testid={'cancel-edit-recipients'} >Cancel</Button>
      <Button disabled={loading || disabled} onClick={onSave} data-testid={'save-edit-recipients'}>Save</Button>
    </div>
  )
}

export const InfoCell = ({ title, content, className, testIdString, loading = false }: { title?: React.ReactNode; content: React.ReactNode; className?: string; testIdString?: string; loading?: boolean; }) => {
  if (loading) {
    return <ContentLoader
      key={testIdHelper(testIdString, "loading")}
      interval={0.5}
      speed={1.75}
      gradientRatio={0.5}
      width='100%'
      height='50px'
      backgroundColor={tandem}
      foregroundColor={foregroundColor}
    >
      <rect data-testid={testIdHelper(testIdString, "loading")} x="0" y="0" width="250" height="16"></rect>
      <rect x="0" y="20" width="125" height="20"></rect>
    </ContentLoader>
  }

  return (
    <div className={styles.infoCell} data-testid={testIdHelper(testIdString, 'cell')}>
      {title && <div className={styles.infoTitle}>{title}</div>}
      <div className={cx(styles.infoContent, className)}>{content}</div>
    </div>
  )
}

export const InfoSection = ({ children, className }: { children: ReactNode; className?: string }) => {
  return (
    <div className={cx(styles.infoSection, className)}>
      {children}
    </div>
  )
}

export const MetricCell = ({ title, content, testIdString, className, loading }: { title: string; content: string; testIdString?: string; className?: string; loading: boolean;}) => {
  if (loading) {
    return <ContentLoader
      key={testIdHelper(testIdString, "loading")}
      interval={0.5}
      speed={1.75}
      gradientRatio={0.5}
      width='100%'
      height='66px'
      backgroundColor={tandem}
      foregroundColor={foregroundColor}
    >
      <rect data-testid={testIdHelper(testIdString, "loading")} x="0" y="2" width="200" height="20"></rect>
      <rect x="0" y="25" width="325" height="18"></rect>
    </ContentLoader>
  }

  return (
    <div className={styles.metricCell} data-testid={testIdHelper(testIdString, 'cell')}>
      {title && <div className={styles.metricTitle}>{title}</div>}
      <div className={cx(styles.metricContent, className)}>{content}</div>
    </div>
  )
}
